export const EN = {
  //Authentication
  login: "Login",
  dont_have_any_account: "Don't have any account?",
  do_you_have_any_account: "Do you have any account?",
  privacy_policy_text: "By clicking continue button or continue through a third party you accept all of Upload The Truth",
  privacy_policy: "Privacy & Policy",
  and_others: "and others.",
  register_now: "Register now",
  forgot_password: "Forgot password?",
  is_it_your_account: "Is it your account?",
  contact_with: "Contact with the",
  support_team: "support team",
  send_otp: "Send OTP",
  an_otp_will_be_sent_to_your_phone: "An OTP will be sent to your Phone / Email",
  email_or_phone: "Phone / Email",
  enter_email_or_phone: "Please enter a Email/Phone number.",
  send: "Send",
  write_appropriate_note: "Write appropriate note here",
  select_date: "Select Date",
  last_activity_date: "Last activity date (optional)",
  recent_password: "Recent password (optional)",
  fb_username: "Facebook username",
  phone: "Phone",
  email_placeholder: "Enter email address",
  contact_email: "Contact email",
  google_account: "Google account",
  account_created_with: "Account Created with",
  continue_with: "Continue with",
  google: "Google",
  facebook: "Facebook",
  whatsapp: "WhatsApp",
  registration: "Registration",
  register: "Register",
  full_name: "Full Name",
  profile_picture: "Profile Picture",
  failed: "Failed!",
  success: "Success",
  an_6_digit_code: "An 6-digit code",
  was_sent: "was sent",
  didnt_receive_code: "Didn't receive the code?",
  resend: "Resend",
  verify: "Verify",
  verify_your_email: "Verify Your Email",
  verify_your_mobile: "Verify Your Mobile",
  please_try_again_after: "Please try again after",
  otp_will_be_expired_in: "The OTP will be expired in",
  is_change: "Change?",
  go_back: "Go Back",
  invalid_otp_code: "Invalid OTP!",
  confirm_your_mobile: "Confirm your mobile number",
  choose_how_you_want_to_confirm: "Choose how you want to confirm that",
  belongs_to_you: "belongs to you.",
  send_code_via_sms: "Send code via SMS",
  send_code_via_whatsapp: "Send code via WhatsApp",
  old_password: "Old Password",
  new_password: "New Password",
  confirm_password: "Confirm Password",

  // Empty
  no_data: "No Data Found",
  there_is_no_data: "There is no data",
  no_data_available: "No data available",
  there_are_no_records_to_display: "There are no records to display",

  //COMMON_TEXT
  welcome: "Welcome",
  welcome_back: "Welcome Back",
  login_your_account: "Login your account",
  notification: "Notification",
  hello: "Hey !",
  happy_to_see_you_again: "Happy to see you again",
  overview: "Overview",
  most_recent: "Most Recent",
  view_all: "View all",
  change_status: "Change Status",
  camera: "Camera",
  gallery: "Gallery",
  image: "IMAGE",
  language: "Language",
  session_timeout: "Session Timeout",
  file: "File",
  go: "Go",
  select_language: "Select Language",
  enter: "Enter",
 
  //Labels
  title: "Title",
  new: "New",
  description: "Description",
  details: "Details",
  optional: "Optional",
  start_date: 'Start Date',
  expire_start_date: 'Expire Start Date',
  expire_end_date: 'Expire End Date',
  end_date: 'End Date',
  active: "Active",
  none: "None",
  n_a: "N/A",
  deactivate: "Deactivate",
  write_here: "Write here",
  select: "Select",
  search_option: "Search Option",
  first_name: "First Name",
  last_name: "Last Name",
  username: 'Username',
  email: "Email",
  mobile: "Mobile",
  new_password: "New Password",
  confirm_new_password: "Confirm New Password",
  select_one: "Select one",
  action: "Action",
  status: "Status",
  type: 'Type',
  total: "Total",
  birth_date: "Birth Date",
  gender: "Gender",
  phone_number: "Phone Number",
  postal_code: "Postal Code",
  address: "Address",
  name: "Name",
  document: "Document",
  note: "Note",
  password: "Password",
  date: "Date",
  city: "City",
  cap: "Cap",
  not_define: "Not Define",
  logo: "Logo",
  advance: "Advance",
  otp: "OTP",
  tags: "Tags",
  report: "Report",
  anonymous: "Anonymous",
  see_more: "...See more",
  optimizing: "Optimizing...",
  you_r_searching_for: "You'r searching for...",

  //Alert
  oops: "Oops",
  are_you_sure: "Are you sure?",
  are_you_sure_to_logout: "Are you sure to logout?",
  you_wont_be_able_to_revert_this: "You won't be able to revert this!",
  are_you_sure_you_want_to_delete: "Are you sure you want to delete?",
  this_action_will_permanently_delete_the_item_and_cannot_be_undone: "This action will permanently delete the item and cannot be undone.",
  yes_delete_it: "Yes, delete it!",
  yes_confirm_it: "Yes, confirm it!",
  page_not_found: "Oops! Page not found",
  back_to_login: "Back to Login",

  login_success: "Login Success",
  login_failed: "Login Failed",
  invalid_username_or_password: "Invalid Username or Password",

  successfully: "Successfully",
  successfully_done: "Successfully Done",
  submitted: "Created Successfully",
  created_successfully: "Submitted!",
  updated_successfully: "Updated Successfully",
  deleted_successfully: "Deleted Successfully",
  status_changed_successfully: "Status changed successfully",

  permission_denied: "Permission Denied",
  permission_denied_message: "Storage permission is required to download the file.",
  please_check_your_permission_and_try_again: "Unless you give us permission, we can't work",
  file_saved_to: "File saved to",
  duplicate_not_allowed: "Duplicate not allowed",
  you_missed_some_required_fields: "You missed some required fields",
  please_check_all_required_fields: "Please check all required fields",
  no_internet_connection: "No Internet Connection",
  please_check_your_internet_connection_and_try_again: "Please check your internet connection and try again.",
  something_went_wrong_try_again: "Something Went Wrong, Try Again",
  something_went_wrong: "Something went wrong",
  we_are_working_on_it: "We're working on it. Your reward journey is still on track!",
  please_try_again_later: "Please try again later.",
  please_try_again: "Please try again.",
  your_item_has_been_deleted: "Your item has been deleted",
  please_enter_empty_field: "Please, enter the empty field !",

  update_location: "Update your Location",
  update_location_description: "We collect user country location to showing better content.",
  thank_you: "Thank you!",

  // SUCCESS_MESSAGES
  forgot_password_support: "We've sent an email to the address you provided with instructions to reset your password.",
  user_contact: 'We will contact you via email shortly.',
  registration_success: 'Registration successful! Welcome to Upload The Truth.',
  password_change: 'Your password has been successfully updated. You can now log in with your new password.',
  comment_added: 'Comment added successfully!',
  report_submitted: 'Thank you! Your report has been submitted.',
  post_saved_success: 'Post saved successfully to your Watch Later list.',
  post_removed_success: 'Post removed successfully to your Watch Later list.',
  post_remove_to_watch: 'Post removed successfully from your Watch Later list.',
  post_remove_from_history: 'Post removed successfully from your history list.',

  // ERROR_MESSAGES
  common_error: "We couldn't complete your request. Please check your connection and try again.",
  validation_error: 'Validation error. Please review your input and try again.',
  registration_error: 'We encountered an issue during registration. Please try again later.',
  registered_but_not_success: 'Thank you for registering! Your data is being verified for security. Please try again in a few minutes.',
  login_validation: 'Invalid credentials. Please verify your credentials and try again.',
  forgot_password_invalid_username: 'Please enter a valid email address or phone number with the correct country code.',
  otp_invalid_phone_whatsapp: 'The phone number you provided is invalid. Please try again.',
  otp_already_sent: 'An OTP has already been sent. Please try again after the current OTP expires.',
  video_compress: 'We are experiencing technical issues. Please try again later.',
  invalid_old_password: 'The old password you entered is incorrect. Please try again.', // during password change
  expired_otp: 'Your OTP has expired. Please request a new one and try again.',
  invalid_otp: 'Please verify the code and try again',
  otp_required: 'Please enter the OTP to proceed.',
  video_thumbnail_problem: 'An issue occurred while creating the thumbnail. Please try again.',
  video_file_not_found: 'The video file could not be found. Please upload it again.', // during upload
  video_upload: 'There was an issue with your video upload. It might be corrupted or there was a network problem. Please try again.',
  notification_error: "No new notifications at the moment. Stay informed, stay involved, and keep uploading the truth!",
  search_error: "No uploads match your search. Try adjusting your keywords or explore other topics to find what you're looking for!",
  home_page_error: "We couldn't load the content at the moment. Please check your connection, refresh the page, or check back shortly!",
  profile_view: "We couldn't load your profile details. Please check your connection and try again.",
  profile_update: "There was an error saving your changes.Please make sure all fields are correct and try again",
  post_manage_data: "We couldn't load your videos. Please check your connection and try again",
  post_update: "Unable to save changes to your video. Please check your connection and try again",
  google_reg: "We couldn't retrieve your information from Google. Please ensure you're connected and try again.",
  facebook_reg: "We couldn't retrieve your information from Facebook. Please ensure you're connected and try again.",
  storage_low: "Your device storage is low. This operation could not complete properly. Please free up some space and try again.",

  //form validation
  required: "This field is required.",
  min_characters: "The input must be at least {min} characters.",
  max_characters: "The input must not exceed {max} characters.",
  //
  name_required: "Please enter name.",
  name_250_characters: "Name must be at most 250 characters",
   //
   full_name_required: "Please enter your full name.",
  //
  phone_required: "Please enter phone number",
  phone_15_characters: "Phone must be at most 15 characters",
  phone_invalid: "Please enter valid phone number.",
  //
  email_required: "Please enter email",
  contact_email_required: "Please enter a contact email",
  email_250_characters: "Email must be at most 250 characters",
  email_invalid: "Please enter valid email.",
  //
  address_required: "Please enter address.",
  address_500_characters: "Address must be at most 500 characters",
  //
  old_password_required: "Please enter old password",
  //
  password_required: "Please enter password",
  password_6_characters: "Password must have at least 6 characters",
  //
  confirm_password_required: "Please re-type your password",
  password_not_match: "Passwords does not match",
  //
  facebook_required: "Please enter facebook username",
  please_select_item: "Please select an item",

  //Button
  done: "Done",
  back: "Back",
  add: "Add",
  add_new: "Add New",
  next: "Next",
  save_and_next: "Save & Next",
  edit: "Edit",
  share: "Share",
  update: "Update",
  submit: "Submit",
  create: "Create",
  remove: "Remove",
  delete: "Delete",
  print: "Print",
  cancel: "Cancel",
  download: "Download",
  search: "Search",
  clear: "Clear",
  yes: "Yes",
  no: "No",
  upload: "Upload",
  upload_file: "Upload File",
  all: "All",
  see_more: "See More",
  or: "Or",
  ok: "Ok",
  to: 'To',
  close: "Close",
  logout: "Logout",
  profile: "Profile",
  preview: "Preview",
  confirm: "Confirm",
  continue: "Continue",
  skip: "Skip",
  change: "Change",

  //Upload Form
  scanning: "Scanning...",
  searching_keywords: "Searching Keywords",
  write_a_keyword_here: "Write a keyword here",
  content_language: "Content's Languages",
  description_write: "Describe what is going on",
  please_write_a_title: "Please write a title",
  please_write_a_text: "Please write a text",
  type_your_text_here: "Type your text here...",
  sub_category: "Sub-Category",
  sub_categories: "Sub-Categories",
  you_can_choose_maximum_3: "(You can choose up to 3)",
  please_select_a_category: "Please select a category",
  select_category: "Select Category",
  category: "Category",
  categories: "Categories",
  post_anonymously: "Post Anonymously",
  hide_your_identity: "Hide your identity",
  create_post: "Create Post",
  upload_audio: "Upload Audio",
  upload_video: "Upload Video",
  display_picture_required: "Display Picture Required",
  content_location: "Content's Location",
  you_can_add_multiple_keywords: "You can add multiple keywords",
  you_can_choose_multiple_languages: "You can choose multiple languages",
  maximum_3: "Maximum 3",
 
  //Months
  Jan: "Jan",
  Feb: "Feb ",
  Mar: "Mar",
  Apr: "Apr",
  May: "May",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Oct",
  Nov: "Nov",
  Dec: "Dec",

  // Time
  minute: "minute",
  minutes: "minutes",
  hour: "hour",
  hours: "hours",
  day: "day",
  days: "days",
  week: "week",
  weeks: "weeks",
  month: "month",
  months: "months",
  year: "year",
  years: "years",
  ago: "ago",
  today: "Today",
  yesterday: "Yesterday",
  days_ago: "days ago",

  //Comments
  comment: "Comment",
  comments: "Comments",
  community_guidelines: "Community Guidelines",
  add_comment_here: "Add Comment here",
  add_your_comment: "Add your comment",
  keep_comment_respectful: "Remember to keep comment respectful and to follow our",

  // Sidebar
  trending: "Trending",
  confession: "Confession",
  audio: "Audio",
  audios: "Audios",
  record_audio: "Record Audio",
  add_details: "Add Details",
  edit_details: "Edit Details",
  post_details: "Post Details",
  coins_history: "Coins History",
  help_feedback: "Help & Feedback",
  basic_info: "Basic Info",
  already_registered: "Already Registered",
  change_password: "Change Password",
  reset_password: "Reset Password",
  forgot_password: "Forgot Password?",
  audio_file: "Audio File",
  video: "Video",
  videos: "Videos",
  image: "Image",
  images: "Images",
  power_play: "Power Play",
  text: "Text",
  texts: "Texts",
  play: "Play",
  utt_coins: "UTT Coins",
  your_reactions: "Your Reactions",
  your_comments: "Your Comments",
  my_uploads: "My Uploads",
  my_supporting: "My Supporting",
  invite_friends: "Invite Friends",
  help_center: "Help Center / FAQs",
  guidelines_rules: "Guidelines & Rules",
  terms_privacy: "Terms of Use . Privacy & Privacy",

  // Version
  version: "Version",
  new_version_available: "New version is available!",
  please_update: "Please update now.",
  update_now: "Update Now",
  later: "Later",

  //Bottom Tabs
  home: "Home",
  pp: "PP",
  save: "Save",
  history: "History",
  upload_your_content: "Upload Your Content",
  save_to_watch_later: "Save to watch Later",
  remove_from_saved: "Remove from saved",
  remove_from_history: "Remove from history",

  //
  app: 'App', //module name
  truth: 'Truth',
  fake: 'Fake',
  view: 'View',
  views: 'Views',
  hide: 'Hide',
  upload_in_progress: "Upload in progress...",
  upload_successful: "Upload Successful",
  profile_info: 'Profile Information', //module name
  manage_activity: 'Manage Your Activity',
  display_channel_name: 'Your Display / Channel Name',
  max_50_words: 'Max 50 words',
  bio_about_yourself: 'Bio / About Yourself',
  max_100_words: 'Max 100 words',
  support: 'Support',
  supporter: 'Supporter',
  supporters: 'Supporters',
  supporting: 'Supporting',
  supportings: 'Supportings',
  total_supporters: 'Total Supporters',
  total_supportings: 'Total Supportings',
  personal_info: "Personal Info",
  home_country: "Home Country",
  home_location: "Home Location",
  current: "Current",
  delivery: "Delivery",
  same_as_home_address: "Same as Home Address",
  same_as_current_address: "Same as Current Address",
  other_address: "Other Address",
  delivery_address_note: "If you win any contest on Upload the Truth, the prize will be sent to this address.",
  select_country: "Select Country",
  current_country: "Current Country",
  current_location: "Current Location",
  location: "Location",
  country: "Country",
  please_select_a_country: "Please select a country",
  please_select_home_country_first: "Please select home country first",
  please_select_current_country_first: "Please select current country first",
  please_select_delivery_country_first: "Please select delivery country first",
  we_collect_user_country_location: "We collect user country location to showing better contents.",
  update_your_location: "Update Your Location",
  please_select_language: "Please select your language",
  privacy_and_security: "Privacy & Security",
  type_otp: "Type your 6 digit OTP",
  terms_and_conditions: "Terms & Conditions",

  setting_and_others: "Setting & Others", //module name
  app_language: "App Language",
  languages: "Languages",
  deactivate_account: "Deactivate/Delete Account",
  contact_us: "Contact Us",
  please_write_number:  "Please write a number",
  please_write_email:  "Please write a email",
  please_enter_a_contact_email: "Please enter a contact email",
  please_write_valid_email: "Please write a valid email",
  please_write_subject: "Please write a subject",
  please_write_message: "Please write a message",
  thank_you: "Thank You!",
  message: "Message",
  write_appropriate_message_here: "Write appropriate message here",
  subject: "Subject",
  reason: "Reason",
  select_reason: "Select Reason",
  please_select_reason: "Please select a reason",
  write_the_reason: "Write the reason",
  please_write_the_reason: "Please write the reason",
  delete_request: "SEND DELETE REQUEST",
  deactivate_message: `It will take a minimum 45 days for deleting completely if you want to delete your account. 
  But within these 45 days, if you login again then the delete request will be cancelled. But in the meantime nobody will find you on this application except the cache data.`,
  support_message: "We'll be reaching out to you via the email address you provided shortly to guide you through the process of resetting your password",

  why_upload_the_truth: "Why upload the Truth ?",
  more_videos: "More Videos",
  no_internet: "No internet",
  confirmation: "Confirmation",
  video_cancel_confirmation_message: "Recorded/selected video will be discard from your app.\nDo you want to do this?",
  trimmingText: "Processing your video",
  video_selection_error:"Oh no ! The video you selected does not exist or it failed to load, sorry",
  restart: "Restart",

  //coins
  total_coins: "Total Coins",
  history: "History",
  coins_history: "Coins History",
  coins: "Coins",
  referral_and_gift: "Referral & gift",
  monetization: "Monetization",
  you_are_not_yet_eligible_for_monetization: "You are not yet eligible for monetization.",
  seven_days_challenges: "7 days challenges",
  how_to_earn_more_utt_coins: "How to Earn more UTT Coins ?",
  what_is_uut_coins: "What is UUT Coins ?",
  how_to_earn_utt_coins: "How to earn UTT Coins ?",
  how_to_use_utt_coins: "How to use UTT Coins ?",
  complete: "Complete",
  give_10_comment: "Give 10 comment",
  upload_3_video_in_crime_category: "Upload 3 video in crime category",
  upload_3_pp: "Upload 3 PP (Power Play)",
  upload_3_audio: "Upload 3 Audio",

  refer_friend_earn: "Refer Friend & Earn",
  copy_your_code: "Copy your code, share it with your friends.",
  your_refer_code: "Your refer code",
  type_your_friends_refer_code: "Type your friends refer code",
  redeem: "Redeem",
  copy: "Copy",
  enter_code: "Enter Code",
  or_share: "OR Share",
  how_it_work: "How It Work ?",
  invite_your_friend_by_using_this_code: "Invite your friend by using this code",
  they_use_this_code: "They use this code.",
  you_get_500_utt_coins: "You get 500 UTT Coins !",
  contact_number: "Contact Number",
  shirt_size: "T-Shirt Size",
  district: "District",
  thana: "Thana",
  delivery_address: "Delivery Address",
  full_address: "full address",
  prize_info_submitted_successfully: "Your prize information has been successfully submitted.",
};